import React, {memo} from 'react';
import {ProductData} from '../../../../types/serverTypes/Account';
import {ProductNutrition} from '../../../../types/ProductType';
import CollapsibleComponent from '../../../elements/CollapsibleComponent';
import AVText from '../../../elements/AVText';
import {StyleSheet, View} from 'react-native';
import {NutritionFactsDisplay} from '../../../elements/NutritionFactsDisplay/NutritionFactsDisplay';
import Localized from '../../../../constants/AppStrings';
import Settings from '../../../../Settings';

export const NutritionSection = memo(
  ({
    product,
    nutrition,
  }: {
    product: ProductData;
    nutrition: ProductNutrition;
  }) => (
    <CollapsibleComponent
      headerAccessibilityLabel="Nutritional facts"
      contentAccessibilityLabel="Nutritional facts"
      isProductRecommendationView
      headerAdditionalStyle={styles.headerAdditionalStyle}
      header={
        <AVText style={styles.nutritionHeaderText}>
          {Localized.Labels.nutrition_facts}
        </AVText>
      }
      content={
        <View>
          <AVText style={styles.nutritionFactsPreContentText}>
            *{Localized.Labels.nutrition_disclaimer}
          </AVText>
          <NutritionFactsDisplay
            product={{...product, calories: nutrition.calories}}
            nutrition={nutrition}
            additionalContainerStyles={styles.nutritionFactsContainer}
          />
        </View>
      }
      containerStyle={styles.dropdownContainer}
      key={product.productId}
    />
  ),
);

const styles = StyleSheet.create({
  nutritionHeaderText: {
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 19,
  },
  nutritionFactsPreContentText: {
    fontWeight: '400',
    fontSize: 12,
    lineHeight: 14,
    marginTop: 8,
  },
  nutritionFactsContainer: {
    marginHorizontal: 0,
  },
  dropdownContainer: {
    backgroundColor: 'transparent',
    borderBottomWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    elevation: 0,
    borderTopWidth: 1,
    borderRadius: 0,
    borderTopColor: '#CFCFCF',
    marginHorizontal: 0,
    paddingHorizontal: 0,
    paddingTop: Settings.isRefiveAnd365PayOnly() ? 8 : 19,
    marginTop: Settings.isRefiveAnd365PayOnly() ? 14 : 18,
  },
  headerAdditionalStyle: {
    padding: 0,
  },
});

NutritionSection.displayName = 'NutritionSection';
